/**
 * @module constants
 */

// Number indicates bottom-line viewport width.
export default {
  SMALL: 0,
  MEDIUM: 500,
  LARGE: 800
};



// WEBPACK FOOTER //
// ./app/constants/viewPortSize.js